













import Vue from 'vue'
import { USER_TIME_ZONE } from '@/utils/time'
import { buildActigraphyOptions } from '@/components/patient-stats/graphs/actigraphy-reports/chart-options/actigraphyOptions'

type CommonBuildOptions = { startTimestamp: number; endTimestamp: number; timezone: string; colors: any }

export default Vue.extend({
  props: {
    startTimestamp: {
      type: Number,
      required: true,
    },
    endTimestamp: {
      type: Number,
      required: true,
    },
    actigraphyReport: {
      type: Object,
      required: true,
    },
  },
  computed: {
    isNoData(): boolean {
      return !this.actigraphyReport?.sleepStates?.length && !this.actigraphyReport?.activityCounts?.length
    },
    buildOptions(): CommonBuildOptions {
      const timezone = this.actigraphyReport.timezone || USER_TIME_ZONE
      return {
        startTimestamp: this.startTimestamp,
        endTimestamp: this.endTimestamp,
        timezone,
        colors: this.$vuetify.theme.themes.light,
      }
    },
    actigraphyOptions(): echarts.EChartOption<echarts.EChartOption.SeriesLine>[] {
      return buildActigraphyOptions({
        ...(this.buildOptions as CommonBuildOptions),
        actigraphyReport: this.actigraphyReport,
      })
    },
    loading() {
      return this.actigraphyReport != null
    },
  },
})
